import { Box, Typography } from "@mui/material"
import { useAppSelector } from "../../app/hooks"
import { selectAnalysisData, selectDomainCss } from "../analysis/AnalysisSlice"
import { ErrorBoundary } from "react-error-boundary"
import { format } from "date-fns"
import { grey } from "@mui/material/colors"
import { selectAuthUser } from "../auth/AuthSlice"

export interface GeneratedOnProps {
  url?: string
}

function GeneratedOn(props: GeneratedOnProps) {
  const analysisData = useAppSelector(selectAnalysisData)
  const domainCss = useAppSelector(selectDomainCss)
  const user = useAppSelector(selectAuthUser)
  const ErrorBoundryFallback = () => <></>
  return (<>
    {analysisData.generatedOn && <ErrorBoundary FallbackComponent={ErrorBoundryFallback} >
      <Typography variant="caption" component="div" m={1} sx={{ textAlign: 'right', color: domainCss?.instructionColor }}>
        Generated on <strong>{format(new Date(analysisData.generatedOn), 'yyyy-MM-dd HH:mm a')}</strong> by <strong>{analysisData.generatedBy ?? user?.email ?? "~"}</strong>
      </Typography>
      {props.url && <Typography variant="caption" component="div" m={1} sx={{ textAlign: 'right', color: domainCss?.instructionColor }}>
        {props.url}
      </Typography>}
    </ErrorBoundary>
    }
  </>)
}

export default GeneratedOn